exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-standard-menu .standard-menu-toggle[data-v-a85d0744]{font-size:.75rem;color:var(--fts-default)}.standard-menu-dropdown .standard-activity[data-v-a85d0744]{font-size:var(--inistate-label-text-14);line-height:var(--inistate-paragraph-text-14--line-height)}.standard-menu-dropdown .standard-activity .standard-activity-icon[data-v-a85d0744]{margin-right:.375rem;color:var(--fts-default)}", ""]);

// exports
